import { BasicLayout} from "../components/shared/Layout";
import { DroitForm } from "../components/pages/vosDroits";
export function DroitClient() {
    return (
        <BasicLayout>
           <DroitForm/>
        </BasicLayout> 
    )
}